import { properties } from 'src/environments/properties';
import { GameService } from 'src/app/shared/services/game/game.service';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonService, J4uV1Service, AemService } from 'abs-ngx-library/src/lib/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-bonus-path',
  templateUrl: './bonus-path.component.html',
  styleUrls: ['./bonus-path.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BonusPathComponent implements OnInit {

  public BonusPath = properties.BonusPath;
  public BonusPathSub = properties.BonusPathSub;
  public Loading = true;
  public gridData: any;
  public gridSettings: any = {
    numberOfColumns: 3,
    hasLoadMore: true,
    buttonText: 'Load More',
    hasInfiniteScroll: false,
    areDigitalCoupons: true
  }
  public logoProps: any = {};
  public calledBy: string = 'gamification'
  constructor(private gameService: GameService, private j4uv1Service: J4uV1Service, public _commonService: CommonService, private aemService: AemService) {

  }
  ngOnInit(): void {
    this.j4uv1Service.getLogoList().subscribe(data => this.logoProps = data);
    this.j4uv1Service.getData(99999, false, true).pipe(
        take(1)
      ).subscribe(data => {
      if(data && !data.length) {
        this.gameService.bonusPath.next({'bonusPathExist': false, BonusPath: data});
      }
      this.gridData = Object.values(data);
    },(error) => {
      this.gameService.bonusPath.next({'bonusPathExist': false, BonusPath: error});
    })
  }
}
